import styled from 'styled-components';
import { ThemeColours } from '../../common/styles/ThemeColours';

export const StyledLink = styled.a`
  color: ${ThemeColours.white};
  margin-inline-start: 8px;
`;

export const Footer = styled.p`
  display: flex;
`;
